import React from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'

import IconButton from '@material-ui/core/IconButton'
import Typography from '@material-ui/core/Typography'
import ArrowBackIcon from '@material-ui/icons/ArrowBack'
import CloseIcon from '@material-ui/icons/Close'

import { makeStyles, useTheme } from '@material-ui/core'

import { RootStoreModel } from '../../../../../../redux'
import { WikiIndexEntryVM } from '../../sidePanel.model'
import { HelpContent, HelpIndex } from '../help'
import { getCurrentPageTitle } from '../help/helpPanel.service'
import { styles } from '../help/helpPanel.styles'
import { fetchChangelogIndex } from './changelog.service'

type ChangelogPanelProps = { onHandleClose: () => void }

export const ChangelogPanel: React.FC<ChangelogPanelProps> = ({ onHandleClose }) => {
  const currentTheme = useTheme()
  const useStyles = makeStyles(styles(currentTheme))
  const classes = useStyles()

  const [t] = useTranslation(['changelog'])

  const currentSection: string = useSelector((state: RootStoreModel) => {
    return state.router && state.router.location && state.router.location.pathname
  })

  const [currentPage, setCurrentPage] = React.useState<string>('')
  const [sectionIndex, setSectionIndex] = React.useState<WikiIndexEntryVM[] | undefined>(undefined)
  const [selectedContent, setSelectedContent] = React.useState<string | undefined>(undefined)
  const [cardSubheader, setCardsubheader] = React.useState<string>(getCurrentPageTitle(currentPage))

  React.useEffect(() => {
    const getIndexForSection = async (section: string) => {
      const indexForCurrentSection: WikiIndexEntryVM[] = await fetchChangelogIndex(section)
      setSectionIndex(indexForCurrentSection)
    }

    if (!open) return

    const currentSectionPath = t(`changelog:sideChangelogRoutes.default`)
    setCurrentPage(currentSectionPath)
    setCardsubheader(getCurrentPageTitle(currentSectionPath))

    getIndexForSection(currentSectionPath)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open, currentSection])

  const handleCloseDrawer = React.useCallback(() => {
    onHandleClose()
  }, [])

  const handleGoBack = React.useCallback(
    (event: React.MouseEvent<HTMLElement>) => {
      setSelectedContent(undefined)
      setCardsubheader(getCurrentPageTitle(currentPage))
    },
    [currentPage]
  )

  const handleIndexEntryClick = React.useCallback((entry: WikiIndexEntryVM) => {
    setSelectedContent(entry.path)
    setCardsubheader(entry.title)
  }, [])

  return (
    <>
      <div className={classes.cardHeader}>
        <div className={classes.cardHeaderTitleContainer}>
          <div>
            <Typography variant="h1" component="h1">
              {t('changelog:title')}
            </Typography>
          </div>
          <div>{cardSubheader}</div>
        </div>
        <div>
          {selectedContent ? (
            <IconButton aria-label="close" onClick={handleGoBack}>
              <ArrowBackIcon />
            </IconButton>
          ) : (
            <IconButton aria-label="close" onClick={handleCloseDrawer}>
              <CloseIcon />
            </IconButton>
          )}
        </div>
      </div>
      <div className={classes.cardContent}>
        {selectedContent ? (
          <HelpContent contentPath={selectedContent} />
        ) : (
          <HelpIndex index={sectionIndex} onClickIndexEntry={handleIndexEntryClick} />
        )}
      </div>

      {/* // Hide open in new tab action until redirection is fixed
           {selectedContent && (
            <div className={classes.cardActions}>
              <Link
                target="_blank"
                to={`/help/${encodeURIComponent(selectedContent)}`}
                className={classes.openInNewTabActionLink}
              >
                <Button size="small" color="primary">
                  {t('help:openInNewTabAction')}
                </Button>
              </Link>
            </div>
          )} */}
    </>
  )
}
